<template>
  <div class="mytest-container">
    <div class="back" @click="goBack">
      <img
        src="@/assets/images/trialProductsList/back.png"
        class="backimg"
        alt=""
      />
    </div>
    <div class="test-user-info">
      <img class="user-icon" :src="getCookie('xmh_headimgurl')" alt="" />
      <div class="user-nickname">{{ getCookie('xmh_nickname') }}</div>
    </div>
    <div class="test-goods-info">
      <div class="test-goods-type">
        <img
          class="kill-gift gift"
          :src="defaultSelect === 1 ? defaultImg[1] : defaultImg[0]"
          alt=""
          @click="defaultSelect !== 1 ? golist(1) : ''"
        />
        <span class="tab-border"></span>
        <img
          class="nokill-gift gift"
          :src="defaultSelect === 0 ? defaultImg[3] : defaultImg[2]"
          alt=""
          @click="defaultSelect !== 0 ? golist(0) : ''"
        />
        <span class="tab-border"></span>
        <img
          class="nokill-gift gift"
          :src="defaultSelect === 2 ? defaultImg[5] : defaultImg[4]"
          alt=""
          @click="defaultSelect !== 2 ? golist(2) : ''"
        />
      </div>
      <van-list
        v-model="lodingParams.loading"
        :finished="lodingParams.finished"
        error-text="请求失败，点击重新加载"
        :finished-text="lodingParams.bottomText"
        @load="getInitMytrialData"
        class="van-listcontainer"
      >
        <!-- 商品列表 -->
        <div class="test-goods-list">
          <div
            class="test-goods-list-wrapper"
            v-for="(item, index) in listData"
            :key="index"
          >
            <div style="display: flex; padding: 16px 0px 13px; height: 105px">
              <img
                class="test-goods-img"
                :src="item.goodsUrl"
                alt=""
                width="92px"
                height="92px"
                style="border-radius: 4px"
              />
              <div class="test-goods-detail">
                <div class="test-goods-title">{{ item.goodsName }}</div>
                <div class="test-goods-btn">
                  <van-count-down
                    v-if="
                      timeBool(
                        defaultSelect === 1
                          ? disposeTime(item.endTime)
                          : defaultSelect === 2
                          ? disposeTime(item.wechatTime)
                          : disposeTime(item.commentTime)
                      )
                    "
                    :time="
                      foramt(
                        defaultSelect === 1
                          ? disposeTime(item.endTime)
                          : defaultSelect === 2
                          ? disposeTime(item.wechatTime)
                          : disposeTime(item.commentTime)
                      )
                    "
                    class="count_down"
                    format="距结束:  DD天  HH:mm:ss"
                  />
                </div>
                <div>
                  <div
                    class="test-goods-status-btn"
                    v-if="defaultSelect === 1"
                    @click="goSignIn()"
                  >
                    提升中奖率
                  </div>
                  <div
                    class="test-goods-status-btn"
                    v-if="defaultSelect === 0"
                    @click="addEnterpriseWechat(disposeTime(item.wechatTime))"
                  >
                    添加企微领奖
                  </div>
                  <div
                    class="test-goods-status-btn"
                    v-if="defaultSelect === 2"
                    @click="goAssessment(item)"
                  >
                    {{ item.commentStatus === 1 ? '发表测评' : '查看测评' }}
                  </div>
                  <div
                    class="tagWrap"
                    v-if="!isSystem && item.status == '已中奖'"
                  >
                    <openWxTag
                      id="xmyxItem1"
                      path="subPackages/shopMainProcess/coupons/couponList"
                      btnStyle="width: 100%; height: 100%; display: block;"
                    >
                    </openWxTag>
                  </div>
                </div>
              </div>
            </div>

            <div class="border"></div>
          </div>
        </div>
        <div class="no_data" v-if="NodeList">
          暂时没有申请的商品，快去申请吧~
        </div>
      </van-list>
    </div>
    <van-popup class="popupCenter" v-model="show" get-container="#app">
      <div class="popup_content">
        <img
          src="@/assets/images/trialProductsList/enterpriseWechat.png"
          width="115px"
          height="115px"
          style="margin: 23px 0 7px"
          alt=""
        />
        <div class="popup_content_title">长按图片识别二维码</div>
        <p>添加星妈会企微领取试用奖品 倒计时结束后未添加则视为放弃奖品</p>
        <button @click="toastButton">保存图片</button>
      </div>
    </van-popup>
    <van-popup class="popupCenter" v-model="endShow" get-container="#app">
      <div class="popup_content">
        <img
          src="@/assets/images/trialProductsList/data.png"
          width="120px"
          height="145px"
          style="margin: 12px 0 7px"
          alt=""
        />
        <div class="popup_content_title" style="margin-top: -30px">
          领奖时间已过
        </div>
        <p>
          请在规定时间内添加星妈会企业微信确认资格领取奖品，结束后无法继续添加微信领取奖品
        </p>
        <button @click="closePopupFn">知道了</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
// import goodList from "./components/goodList.vue";
import API from '@/utils/axiosApi/zeroShoppingApi.js'
import openWxTag from '@/components/common/openWeappTag/index.vue'
import { BuiedPointClick_Fn } from '@/assets/js/BuriedPointEvent'
import {
  getCookie,
  getUserInfo,
  TestUserAgent,
  goToMini,
  Debounce,
} from '@/assets/js/common.js'
import { freetrialView } from '@/utils/freetrialClick.js'
import { assert } from 'console'
export default {
  components: { openWxTag },
  data() {
    return {
      defaultSelect: '', //当前默认选中的tab
      defaultImg: [
        require('@/assets/images/trialProductsList/applying_default.png'),
        require('@/assets/images/trialProductsList/applying_active.png'),
        require('@/assets/images/trialProductsList/gift_default.png'),
        require('@/assets/images/trialProductsList/gift_active.png'),
        require('@/assets/images/trialProductsList/assessment_default.png'),
        require('@/assets/images/trialProductsList/assessment_active.png'),
      ],
      listParams: {
        type: 1,
        pageNum: 1,
        pageSize: 10,
        crmId: this.getUserInfo(),
      },
      lodingParams: {
        //list加载参数
        loading: false, //加载中
        finished: false,
        bottomText: '', //加载完文案
      },
      listData: [], //列表数据
      isSystem: TestUserAgent().isios,
      NodeList: false, //空状态
      show: false,
      endShow: false,
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getCookie,
    getUserInfo,
    golist(type) {
      this.NodeList = false
      this.listData = []
      this.defaultSelect = type
      // 初始化数据  从第一页加载
      this.listParams.type = type
      this.listParams.pageNum = 1
      this.listParams.pageSize = 10
      this.lodingParams.bottomText = ''
      this.lodingParams.finished = false
      this.getInitMytrialData()
    },
    //获取列表数据
    getInitMytrialData: Debounce(function () {
      API.getMytrialList({}, this.listParams, (res) => {
        if (res.code === 200 && res.data != null) {
          const { data, total } = res.data
          this.listData = [...this.listData, ...data]
          if (total === 0) {
            this.NodeList = true
          } else {
            this.NodeList = false
          }
          console.log(3333, this.listData)
          this.$nextTick(() => {
            if (this.listData.length >= total) {
              this.lodingParams.finished = true
            } else {
              this.listParams.pageNum += 1
              this.lodingParams.loading = false
            }
          })
        } else {
          this.$toast({
            message: res.message,
            duration: 2000,
            forbidClick: true,
            context: this,
          })
        }
      })
    }),
    goBack() {
      if (window.history.length > 1) {
        this.$router.back(-1)
      } else {
        this.$router.push({ path: '/trialProducts' })
      }
    },
    // 提升中奖率
    goSignIn() {
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_mytrial_click: '提升中奖率',
      })
      setTimeout(() => {
        location.href=
          location.origin +
            '/member/mine/newPoint?source=trialApplication&redirect=' +
            encodeURIComponent(window.location.href)
      })
    },
    // 添加企业微信
    addEnterpriseWechat(time) {
      let bool = this.timeBool(time)
      bool ? (this.show = true) : (this.endShow = true)
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_mytrial_click: '添加企业微信',
      })
    },
    // 跳转测评
    goAssessment(data) {
      let { id, commentStatus, commentId } = data
      if (commentStatus === 3) {
        this.$toast({
          message: '测评已被删除',
          duration: 2000,
          forbidClick: true,
          context: this,
        })
        return
      }
      if (commentStatus === 1) {
        this.$router.push({ path: '/publishEvaluation/' + id })
        BuiedPointClick_Fn('xmhh5_Freetrial_click', {
          xmhh5_freetrial_mytrial_click: '发表测评',
        })
      }
      if (commentStatus === 2) {
        this.$router.push({ path: '/evaluationDetail/' + commentId })
        BuiedPointClick_Fn('xmhh5_Freetrial_click', {
          xmhh5_freetrial_mytrial_click: '查看测评',
        })
      }
    },
    foramt(stringTime) {
      stringTime = stringTime ? stringTime : '2022-12-03 12:00:00'
      let timestamp2 = new Date(stringTime.replace(/-/g, '/'))
      return timestamp2 - new Date()
    },
    toastButton() {
      this.$toast({
        message: '长按二维码保存图片',
        duration: 2000,
        forbidClick: true,
        context: this,
      })
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_mytrial_click: '保存图片',
      })
    },
    timeBool(time) {
      //当前时间
      let newDate = Date.parse(new Date())
      time = Date.parse(time)
      return time > newDate
    },
    // 处理日期格式 兼容苹果手机
    disposeTime(time) {
      let Newtime = '2023-02-15 00:00:00'
      if (time) {
        Newtime = time.split('-')
        Newtime = Newtime.join('/')
      }
      return Newtime
    },
    closePopupFn() {
      this.endShow = false
      BuiedPointClick_Fn('xmhh5_Freetrial_click', {
        xmhh5_freetrial_mytrial_click: '知道了',
      })
    },

    // jumpLink(test) {
    //   if (test == "申请中") {
    //     // localStorage.setItem("signin_source", "我的试用")

    //   } else if (test == "已中奖") {
    //     if (this.isSystem) {
    //       goToMini(
    //         "xmyxItem1",
    //         "subPackages/shopMainProcess/coupons/couponList"
    //       );
    //     }
    //   }
    // },
  },
  beforeRouteEnter(to, from, next) {
    if (
      from.name === 'publishEvaluation' ||
      (from.name && from.name.indexOf('evaluationDetail') != -1)
    ) {
      next((vm) => {
        vm._data.defaultSelect = 2
        vm._data.listParams.type = 2
      })
    } else {
      next((vm) => {
        vm._data.defaultSelect = 1
        vm._data.listParams.type = 1
      })
    }
    next()
  },

  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    freetrialView({
      xmhh5_Freetrial_pageview: '我的试用',
    })
    // this.golist(1)
  },
}
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
.mytest-container {
  width: 375px;
  min-height: calc(100vh - 9px);
  background: linear-gradient(
    2deg,
    #ededed 0%,
    #f8f1ee 52%,
    #fb4651 90%,
    #f95a64 100%
  );
  filter: blur(0px);
  padding-top: 9px;
  padding-bottom: 20px;

  .test-user-info {
    display: flex;
    box-sizing: border-box;
    width: 352px;
    height: 65px;
    margin: 0 12px;
    padding: 0 8px;
    background: #ffffff;
    border-radius: 8px;
    margin: 0 auto;
    align-items: center;

    .user-icon {
      width: 43px;
      height: 44px;
      border-radius: 50%;
      margin-right: 7px;
    }

    .user-nickname {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
  }
}

.test-goods-info {
  width: 351px;
  margin: 6px auto 0px;
  // min-height: 500px;
  // height: calc(100vh - 107px);
  display: flex;
  flex-direction: column;
  // height: 100vh;
  background: #ffffff;
  border-radius: 8px;

  .test-goods-type {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 16px 62px 3px;
  }

  .gift {
    width: 48px;
    height: 16px;
    //  text-align: left;
  }

  .tab-border {
    width: 1px;
    height: 15px;
    background-color: #999999;
  }
}

.popup_content {
  width: 274px;
  height: 280px;
  background: linear-gradient(180deg, #f9f3f1 0%, #ffffff 20%, #ffffff 100%);
  text-align: center;
  border-radius: 9px;
  .popup_content_title {
    height: 24px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
    text-align: center;
    margin-bottom: 6px;
  }
  p {
    width: 253px;
    height: 33px;
    font-size: 12px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #333333;
    line-height: 16.5px;
    margin: 0 11px 0 10px;
  }
  button {
    width: 226px;
    height: 50px;
    background: linear-gradient(309deg, #fe9196 0%, #fb757d 100%);
    border-radius: 25px;
    border: 1px solid #ffffff;
    margin-top: 12px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }
}

.test-goods-list {
  padding: 0px 7px;
  height: auto;

  .test-goods-list-wrapper {
    width: 338px;
  }

  .border {
    width: 338px;
    height: 1px;
    background-color: #979797;
    margin: 0 auto;
    opacity: 0.15;
  }

  .test-goods-img {
    width: 92px;
    height: 92px;
    border-radius: 4px;
  }

  .test-goods-detail {
    padding-left: 22px;
    position: relative;

    .test-goods-title {
      width: 226px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      height: 42px;
      line-height: 21px;
      overflow: hidden;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }

    .test-goods-btn {
      display: flex;
      margin: 1px 0 2px;
      height: 20px;
      /deep/ .van-count-down {
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #666666;
        line-height: 18px;
      }

      .test-goods-status {
        height: 18.5px;
        // margin-right: 70px;
        font-size: 13px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #333333;
        line-height: 18.5px;
      }
    }
    .test-goods-status-btn {
      background: linear-gradient(180deg, #fc636d 0%, #fc6a72 100%);
      border-radius: 18px;
      padding: 0px 12px;
      display: flex;
      align-items: center;
      height: 27px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 21px;
      position: absolute;
      right: 11px;
    }
  }
}

.tagWrap {
  width: 60px;
  height: 21px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.back {
  padding: 0px 0px 5px 7px;

  img {
    width: 19px;
    height: 19px;
  }
}

.no_data {
  box-sizing: border-box;
  width: 100%;
  height: 210px;
  padding-top: 144px;
  background: url(../../../../assets/images/trialProductsList/no_data.png)
      no-repeat center 26px,
    #ffffff;
  background-size: 104px 122px;
  border-radius: 8px;
  font-size: 15px;
  color: #999999;
  line-height: 22px;
  text-align: center;
}

/deep/ .van-list__loading {
  background-color: #fff;
}

.van-listcontainer {
  flex: 1;
  height: 100%;
  min-height: 667px;
}
.popupCenter {
  border-radius: 9px;
}
</style>
